<template>
   <!-- whole card is clickable. [theme class css in cms-themes.scss] -->
   <a class="flex h-full flex-col" :class="`theme-${containerTheme}`" :href="cta.url">
      <section class="h-[12.5rem] w-full md:max-lg:h-[18.75rem] lg:max-xl:h-[12.1875rem] xl:h-60">
         <LazyLoadingBGimage backgroundSizePosClasses="rounded-t-xl bg-cover bg-center" dontFadeIn :mainSrc="image" />
      </section>
      <section
         class="flex flex-auto flex-col items-start justify-between p-6 text-left md:max-lg:p-10 lg:max-xl:p-12 xl:p-16"
      >
         <h1 class="text-3xl text-lighter">{{ heading }}</h1>
         <div class="flex w-full flex-row items-center justify-end">
            <PageCTAItems v-if="cta" :ctas="[cta]" :localeId="localeId" :theme="containerTheme" :isPageCta="false" />
         </div>
      </section>
   </a>
</template>

<script setup lang="ts">
import type { LinkElementData } from "@/components/ui/LinkElement.vue";
import { Theme, type ContainerTheme } from "@/types";

const props = withDefaults(
   defineProps<{
      heading: string;
      datePublished: string;
      image: string;
      cta: LinkElementData; // articles are only links
      theme?: ContainerTheme;
      // locale ID to use in the links
      // NOTE: This will be set to null whenever we default to the session locale (e.g., 'about-us' blogpost link),
      // while it will be defined for any study-related link (e.g., link for continuing a flow)
      localeId?: string | null;
   }>(),
   {
      theme: Theme.Grey,
      localeId: null,
   }
);

const containerTheme = computed(() => (!props.theme ? Theme.Grey : props.theme));
</script>

<style scoped lang="scss"></style>
